
import * as defaultImport from "@splunk/themes/useSplunkTheme";
export * from "@splunk/themes/useSplunkTheme";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
